import * as fromDatatype from '../datatype-library';


export interface bl_fi_mst_label_fi_item_default_by_category_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    default_einvoice_classification_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_fi_mst_label_fi_item_default_by_category_hdr_RowClass implements bl_fi_mst_label_fi_item_default_by_category_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    default_einvoice_classification_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_tax_id_no: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_submission_type: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
    default_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
